export default "__VITE_ASSET__ODEMHz2k__"